import { AxiosError } from 'axios';

import {
  REQUESTER_LINK__FETCH_FAILURE,
  REQUESTER_LINK__FETCH_REQUEST,
  REQUESTER_LINK__FETCH_SUCCESS,
} from '@app/store/actionTypes';

export function fetchRequesterLink(payload: { documentId: string; exitPath?: string }) {
  return {
    type: REQUESTER_LINK__FETCH_REQUEST,
    payload,
  };
}

export function fetchRequesterLinkSuccess() {
  return {
    type: REQUESTER_LINK__FETCH_SUCCESS,
  };
}

export function fetchRequesterLinkFailure(error: AxiosError) {
  return {
    type: REQUESTER_LINK__FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

export type RequesterLinkAction =
  | ReturnType<typeof fetchRequesterLink>
  | ReturnType<typeof fetchRequesterLinkSuccess>
  | ReturnType<typeof fetchRequesterLinkFailure>;
